const Role = Object.freeze({
  SYSTEM_DEVELOPER: 'System Developer'
})

export default Role
